import a from "../cancel/CanceledError.js";
import s from "../core/AxiosError.js";
import m from "../utils.js";
var h = function h(e, t) {
  var _e = e = e ? e.filter(Boolean) : [],
    l = _e.length;
  if (t || l) {
    var u = new AbortController(),
      f;
    var n = function n(r) {
      if (!f) {
        f = !0, i();
        var o = r instanceof Error ? r : this.reason;
        u.abort(o instanceof s ? o : new a(o instanceof Error ? o.message : o));
      }
    };
    var c = t && setTimeout(function () {
      c = null, n(new s("timeout ".concat(t, " of ms exceeded"), s.ETIMEDOUT));
    }, t);
    var i = function i() {
      e && (c && clearTimeout(c), c = null, e.forEach(function (r) {
        r.unsubscribe ? r.unsubscribe(n) : r.removeEventListener("abort", n);
      }), e = null);
    };
    e.forEach(function (r) {
      return r.addEventListener("abort", n);
    });
    var b = u.signal;
    return b.unsubscribe = function () {
      return m.asap(i);
    }, b;
  }
};
export { h as default };
